import styled from "styled-components";

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
    max-width: 842px;
    margin: 0 auto;
    margin-bottom: 32px;

    @media (min-width: 850px){
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
    }
  }

  p{
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
    max-width: 842px;
    margin: 0 auto;
  }
`;

export const Content = styled.div`
  
`